
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import SbToolbarBtn from '@/components/stead/workspaces/stepbuilder/sbToolbarBtn.vue';
import { stepStatus, TerminalReportStep, WsStepDataMessage } from '@/models/terminal.model';
import { StepLightDocument } from "@/models/step.model";
import { reportStepIcon } from "@/shared/document.icon";

@Component({
  components: {SbToolbarBtn}
})
export default class SbFlowOneStep extends Vue {
  // Les props
  @Prop() private pos!: number
  @Prop({default: false}) private isSelected!: boolean
  @Prop({default: false}) private connected!: boolean
  @PropSync('cursor', {default: -1}) private stepCursor!: number

  // Les propriétés
  // Les propriétés calculées
  private get step(): StepLightDocument {
    return this.steps[this.pos]
  }

  private get steps(): StepLightDocument[] {
    return this.$store.state.step.steps
  }

  private get theme() {
    return this.$store.state.testcase.theme
  }

  private get lineStyle() {
    let style = `border-color: ${this.theme.tree.doc1};`
    if (this.isSelected) {
      style += `background-color: ${this.theme.background};`
    }
    return style
  }

  private get shotid() {
    return this.shot_id(this.step)
  }

  private get totype() {
    return this.$store.getters['forge/totype'](this.step.tobject.type)
  }

  private get instruc() {
    return this.$store.getters['forge/instruction'](this.step.instruc)
  }

  private get loadingScreen() {
    return this.$store.state.step.shotloading
  }

  private get urlShot(): string {
    return !this.loadingScreen ? this.$store.getters['step/shotUrl'](this.shotid) : ''
  }

  private get showImg() {
    let prevStep = null;
    for (let pos = this.pos - 1; pos >= 0; pos--) {
      if (this.steps[pos].tobject.kind === 'Toy') {
        prevStep = this.steps[pos]
        break
      }
    }
    if (prevStep) {
      const curshotid = this.shotid
      const preshotid = this.shot_id(prevStep);
      return curshotid != preshotid
    }
    return true
  }

  private get isConnected() {
    return this.$store.state.runner.ioTerm.isConnected()
  }

  private get stepLog(): TerminalReportStep | null {
    // console.log(`stepLog for #${this.pos} `, this.$store.getters['runner/stepRunReport'](this.pos))
    const wsData: WsStepDataMessage = this.$store.getters['runner/stepRunReport'](this.pos)
    return wsData ? wsData.logs : null
  }

  private get stepLogIcon(): string {
    if (this.stepLog) {
      return reportStepIcon(this.instruc.checking, this.stepLog.status)
    } else {
      return ''
    }
  }

  private get stepLogColor(): string | undefined {
    let color = undefined
    if (this.stepLog) {
      if ((this.stepLog.status as number) === 0) {
        // TODO renvoyer 'error' si un level =2 dans la liste des messages
        if (this.stepLog.messages) {
          const idx = this.stepLog.messages.findIndex((msg) => msg.level === 2)
          color = idx >= 0 ? 'error' : 'warning'
        } else {
          color = 'warning'
        }
      } else {
        color = this.instruc.checking ?  this.stepLog.status === stepStatus.pass ? 'success' : 'error' : 'primary'
      }
    }
    // console.log(`stepLogColor for #${this.pos}`, color)
    return color
  }

  private get iconName(): string {
    const cursor = this.$store.state.runner.cursor
    const findIdx = this.$store.state.runner.breakpoints.findIndex((b: number) => b === this.pos)
    if (findIdx === -1) {
      return this.isConnected && cursor === this.pos ? 'mdi-arrow-right-bold' : ''
    } else {
      return this.isConnected && cursor === this.pos ? 'mdi-arrow-right-bold-circle' : 'mdi-circle'
    }
  }

  private get running(): boolean {
    return this.$store.getters['runner/running'](this.pos)
  }

  // Les hooks
  // Les méthodes surveillées
  // Les méthodes d'instance
  private setBreakpoint(pos: number) {
    const bpts = this.$store.state.runner.breakpoints
    const br = bpts.findIndex((b: number) => b === pos)
    br === -1 ? bpts.push(pos) : bpts.splice(br, 1)
    this.$store.commit('runner/setBreakpoints', bpts)
  }

  private onClick(pos: number) {
    this.$emit('click', pos === this.steps.length ? pos-- : pos)
  }

  private onInsert() {
    this.$emit('insert')
  }

  private onDelete() {
    this.$emit('delete')
  }
  private onDblClick(pos: number) {
    this.$store.commit('runner/setCursor', pos)
  }

  // Les méthodes statiques
  private shot_id = (step: StepLightDocument) => {
    return step && step.tobject && step.tobject.screenshot ? step.tobject.screenshot : null
  }
}
